import React, { Fragment, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Container, Row, Col } from 'react-bootstrap';

import config from '../../../config.js';

import { getConfig } from '../../Config/ConfigActions.js';

import LazyLoader from '../../../components/Content/LazyLoader.js';
import UserGroupPanel from '../../User/components/view/UserGroupPanel.js';
import CmsPanel from '../../Cms/components/content/CmsPanel.js';

import UserNewsletterSubscribe from '../../User/components/newsletter/UserNewsletterSubscribe.js';
import { getUserGroup, getUserGroupOption } from '../../User/UserGroupActions.js';

function PreFooter({ userGroup, isSubscriptionDisabled = false }) {
    return (
        <Fragment>
			<div className="py-md-4 bg-white">
				<Container>
					<Row className="g-0 py-3">
						<Col xs="12" lg="6">
							<UserGroupPanel />
						</Col>
						<Col xs="12" lg="6">
							<UserNewsletterSubscribe />
						</Col>
					</Row>
				</Container>
			</div>
			{/* <CmsPanel slug={`prefooter-${userGroup?.identifier || userGroup}`} /> */}
			{/* {(!userGroup || getUserGroupOption(userGroup, 'allowSubscription')) && !isSubscriptionDisabled && (
			)} */}
        </Fragment>
    );
    // return null;
}

function mapStateToProps(store, props) {
	return {
		userGroup: getUserGroup(store),
		isSubscriptionDisabled: !!getConfig(store, 'is-subscription-disabled'),
	};
}

PreFooter.propTypes = {
	userGroup: PropTypes.object.isRequired,
	isSubscriptionDisabled: PropTypes.bool,
};

export default connect(mapStateToProps)(PreFooter);
